var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-content-container"},[(this.$slots.default != null)?_c('MaxWidthContainer',{attrs:{"size":"lg"}},[_vm._t("default")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }